let activePopup = null;

document.addEventListener('click', e => {
    const trigger = e.target.closest('.popup-trigger');

    if (!trigger) {
        if (activePopup) closePopup(activePopup);
        return;
    }

    const popup = trigger.nextElementSibling;

    if (activePopup && activePopup !== popup) {
        closePopup(activePopup);
    }

    if (!popup.classList.contains('active')) {
        showPopup(popup, trigger);
    } else {
        closePopup(popup);
    }
});

function showPopup(popup, trigger) {
    popup.innerHTML = trigger.dataset.popupHtml;
    popup.classList.add('active');
    popup.classList.add('block');
    popup.classList.remove('hidden');
    trigger.setAttribute('aria-expanded', 'true');
    activePopup = popup;

    const rect = popup.getBoundingClientRect();
    const viewportWidth = document.documentElement.clientWidth;

    if (rect.right > viewportWidth - 20) {  // 20px buffer
        const overflow = rect.right - viewportWidth;
        popup.style.left = `${-overflow - 20}px`;  // Juster left posisjon
    }
}
function closePopup(popup) {
    popup.classList.remove('active');
    popup.classList.remove('block');
    popup.classList.add('hidden');
    popup.previousElementSibling.setAttribute('aria-expanded', 'false');
    activePopup = null;
}